module.exports = __webpack_public_path__ + "img/security2.e772008e.png";